import { render, staticRenderFns } from "./SendReport.vue?vue&type=template&id=5be0289c&"
import script from "./SendReport.vue?vue&type=script&lang=ts&"
export * from "./SendReport.vue?vue&type=script&lang=ts&"
import style0 from "./SendReport.vue?vue&type=style&index=0&id=5be0289c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports